import { render, staticRenderFns } from "./HomeSeriPPPK.vue?vue&type=template&id=8fb118a0&"
import script from "./HomeSeriPPPK.vue?vue&type=script&lang=js&"
export * from "./HomeSeriPPPK.vue?vue&type=script&lang=js&"
import style0 from "./HomeSeriPPPK.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VImg,VRow})
